export default __webpack_public_path__ + "static/media/chaoticblast.487ffb1d.png";